module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-返回顶部.a10b4.png";